



































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { getNewLostPatientChartData } from '@/services/dashboard';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy'
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages,
    UiDatePicker,
  },
})
export default class NewLostPatientChartsV2 extends BaseComponent {
  @Prop()
  public idsBusinessUnits: number[];

  date = new Date().toISOString();

  loading = false;
  error = false;
  private show: boolean = false;
  private chartData: any[] = [];

  private chartOptions = {
    //curveType: 'function',
    backgroundColor: 'transparent',
    /*width: 500,*/
    height: 60,
    chartArea: { left: '100', top: '0', right: '50', bottom: '20' },
    legend: { position: 'none' },

    hAxis: {
      minValue: 0,
      textStyle: {
        fontSize: 13,
      },
    } /*,
    vAxis: {
      title: null,
      minValue: 0,
    },*/,
  };

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.date = new Date().toISOString();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return getNewLostPatientChartData(filter);
        }),
      )
      .subscribe(
        (res) => {
          this.loading = false;
          this.chartData.push(['Pacientes', 'Quantidade', { role: 'style' }, this.columnAnnotation]);
          res.forEach((i) => {
            this.chartData.push([i.id, i.valor, `color: ${i.id == 'Novos' ? 'green' : 'red'}`, i.valor]);
          });
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );

    this.prepareLoad();
    setTimeout(() => {
      this.show = true;
    }, 100);
  }

  load() {
    this.loadByType();
  }

  columnAnnotation = { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' };

  loadByType() {
    this.chartData.splice(0, this.chartData.length);
    let filtro = this.buildFiltro();
    this.execBehaviorSub$.next(filtro);
  }

  buildFiltro() {
    let filtro: any = {};
    filtro.data = this.date ? dateFormat(this.date, 'US') : null;
    filtro.idsEmpresas = this.idsBusinessUnits;

    return filtro;
  }

  @Watch('date')
  @Watch('idsBusinessUnits')
  public onChangeDates() {
    this.prepareLoad();
  }

  timeoutDatesChange = null;
  public prepareLoad() {
    clearTimeout(this.timeoutDatesChange);
    this.timeoutDatesChange = setTimeout(() => {
      this.load();
    }, 100);
  }
}
